// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:600);"]);
// Module
exports.push([module.id, "#app{font-family:Source Sans Pro,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center}.bg-primary{background-color:#1a9bd7!important}a{color:#1a9bd7}", ""]);
// Exports
module.exports = exports;
